import { SmsCostLabel } from '../../shared/sms-cost';
import styles from './channels-item.module.scss';

export interface PreviewChannel {
  label: string;
  count: number;
  smsCostLabel?: string | null;
}

interface PreviewChannelsItemProps {
  channel: PreviewChannel;
}

export const PreviewChannelsItem = ({ channel }: PreviewChannelsItemProps) => {
  return (
    <div className={styles.previewChannelsItem}>
      <div className={styles.previewChannelsRow}>
        <span className={styles.previewChannelsLabel}>{channel.label}</span>
        <span className={styles.previewChannelsCountWrap}>
          <span className={styles.previewChannelsCount}>{channel.count}</span>
          <span className={styles.previewChannelsUnit}>шт.</span>
        </span>
      </div>
      {channel.smsCostLabel && (
        <div className={styles.previewChannelsSmsCostSlot}>
          <SmsCostLabel label={channel.smsCostLabel} />
        </div>
      )}
    </div>
  );
};
